import React, { Component } from 'react';
import ServerError from '../pages/500';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: '',
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error) {
        // You can also log the error to an error reporting service
        this.setState({ error });
    }

    render() {
        const { hasError, error } = this.state;

        if (hasError) {
            // You can render any custom fallback UI
            return <ServerError err={error} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
